module.exports = __webpack_public_path__ + "img/2.38524d46.webp";